import moment from 'moment';

import { I18N_FORMAT_MAP } from '@rover/kibble/styles';
import { ServiceType as RSDKServiceType } from '@rover/rsdk/src/apiClient/latest';
import { DATE_FIELDS } from '@rover/shared/js/constants/searchPage.constants';
import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import { DateRange } from '@rover/types/src/datetime/DateRange';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';
import type { ServiceType, ServiceTypeSlug } from '@rover/types/src/ServiceType';

export const getDateAtNoon = (date: Date): Date =>
  date && new Date(new Date(date).setHours(12, 0, 0, 0));
export const getFormattedDate = (date: Date, language: string): string => {
  const isoFormat = I18N_FORMAT_MAP[language].DATE_ISO;
  const dateAtNoon = getDateAtNoon(date);
  return moment.utc(dateAtNoon).format(isoFormat);
};

export const setDatesIfExists = (
  searchParams: URLSearchParams,
  dateRange: Partial<DateRange>,
  language: string
): void => {
  DATE_FIELDS.forEach((dateField) => {
    if (dateField in dateRange && dateRange[dateField]) {
      searchParams.set(
        searchFilterKeysMap[dateField],
        getFormattedDate(dateRange[dateField], language)
      );
    }
  });
};

/**
 * @description Sets the start and end date based on specific requirements.
 * If the frequency is repeat and the serviceType is defined and supportsDayOfWeekSearch then endDate is removed.
 *
 * @param searchParams
 * @param startDate
 * @param endDate
 * @param language
 * @param frequency
 * @param serviceTypeSlug
 * @param serviceType
 */
export const setDates = (
  searchParams: URLSearchParams,
  startDate: Date | null | undefined,
  endDate: Date | null | undefined,
  language: string,
  frequency: ServiceFrequencyEnum | undefined,
  serviceTypeSlug: ServiceTypeSlug | undefined,
  serviceType: ServiceType | RSDKServiceType | null | undefined
): void => {
  setDatesIfExists(searchParams, { startDate, endDate }, language);

  if (
    frequency === ServiceFrequencyEnum.REPEAT &&
    searchParams.has(searchFilterKeysMap.endDate) &&
    serviceTypeSlug &&
    serviceType?.supportsDayOfWeekSearch
  ) {
    searchParams.delete(searchFilterKeysMap.endDate);
  }
};
